module.exports = __webpack_public_path__ + "img/kv-m.b13773c0.png";